import React from 'react'

import { Button } from '@fourthwall/components'

import * as S from './KlaviyoGetStarted.styled'

type KlaviyoGetStartedProps = {
  refreshLists: () => Promise<void>
  isRefreshing: boolean
}

export const KlaviyoGetStarted = ({ refreshLists, isRefreshing }: KlaviyoGetStartedProps) => {
  const handleGetStarted = async () => {
    try {
      await refreshLists()
    } catch (error) {
      console.error('Failed to refresh Klaviyo lists:', error)
    }
  }

  return (
    <S.Container>
      <S.Title>Connect with Klaviyo</S.Title>
      <S.Description>
        Integrate your Fourthwall shop with Klaviyo to automatically sync customer data and create
        powerful email marketing campaigns.
      </S.Description>
      <S.ButtonContainer>
        <Button
          label="Get Started"
          appearance="primary"
          loading={isRefreshing}
          disabled={isRefreshing}
          onClick={handleGetStarted}
        />
      </S.ButtonContainer>
    </S.Container>
  )
}
